import React from 'react';
import { BRAND_NAME } from '../config/brand';
import logo from '../assets/brand/luzu-points-logo.png';

interface DrupiLogoProps {
  /** Alto (y ancho: el logo es cuadrado) en px. */
  height?: number;
}

// Logo de marca (imagen cuadrada, pedido de TikTok 2026-07-29: el mismo icono
// consistente en la app de TikTok, el sitio y el favicon). Reemplaza al viejo
// wordmark de texto {BRAND_NAME}; el nombre queda como alt por accesibilidad.
export const DrupiLogo: React.FC<DrupiLogoProps> = ({ height = 24 }) => (
  <img
    src={logo}
    alt={BRAND_NAME}
    style={{
      display: 'block',
      height,
      width: height,
      borderRadius: Math.round(height * 0.22),  // esquinas tipo app-icon (el PNG es fondo negro pleno)
    }}
  />
);
